export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvInputbox.vue?vue&type=template&id=7c1d7994&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvInputbox.vue?vue&type=template&id=7c1d7994&lang=pug&
// module id = 131
// module chunks = 0 1